import { ServiceBase } from '../api/ServiceBase';

const endpoint = 'pesagens'
const endpointFull = 'limited_pesagens'
const endpointFullById = 'full_pesagens_by_id'
const endpointDesativarPesagem = 'desativar_pesagem'
const endpointImpressaoTermica = 'impressao_termica'

/**
 * Método responsável buscar todos os pesagens na api
 */
async function getPesagens() {
    try {
        var data = await ServiceBase.getByParams(endpoint);
        return data;
    } catch (e) {
        throw e;
    }
}

async function getPesagensFull(aberto) {
    try {
        var data = await ServiceBase.getByParams(`${endpoint}/${endpointFull}`,{ 'is_ativo': aberto ? 'True' : 'False' });
        return data;
    } catch (e) {
        throw e;
    }
}

async function getPesagemById(id) {
    try {
        var data = await ServiceBase.getByParams(`${endpoint}/${endpointFullById}`, { 'id': id });
        return data;
    } catch (e) {
        throw e;
    }
}

async function postPesagem(pesagem) {
    try {
        var data = await ServiceBase.postData(endpoint, pesagem)
        return data;
    } catch (e) {
        throw e;
    }
}

async function postImpressaoTermica(values) {
    try {
        var data = await ServiceBase.postData(`${endpoint}/${endpointImpressaoTermica}`, values)
        return data;
    } catch (e) {
        throw e;
    }
}

async function putPesagem(pesagem) {
    try {
        var data = await ServiceBase.putData(`${endpoint}/${pesagem.id}/`, pesagem)
        return data;
    } catch (e) {
        throw e;
    }
}

async function desativarPesagem(id) {
    try {
        var data = await ServiceBase.putData(`${endpoint}/${endpointDesativarPesagem}/`, {'id':id})
        return data;
    } catch (e) {
        throw e;
    }
}

export const PesagemService = {
    getPesagens,
    getPesagensFull,
    getPesagemById,
    postPesagem,
    putPesagem,
    desativarPesagem,
    postImpressaoTermica
}